// extracted by mini-css-extract-plugin
module.exports = {"like-cards":"LikeCards_like-cards__HIXtb","big":"LikeCards_big__CRvCF","aspect-ratio":"LikeCards_aspect-ratio__xNe3Q"};